export default __webpack_public_path__ + "static/media/cir-logo.6fda2c20.png";